export const CHANGE_SELECTED_MENU = 'CHANGE_SELECTED_MENU';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_BIZ_SERVICES_DATA = 'SET_BIZ_SERVICES_DATA';
export const SET_REAL_ESTATE_DATA = 'SET_REAL_ESTATE_DATA';
export const SET_BUY_SELL_DATA = 'SET_BUY_SELL_DATA';
export const SET_OFFERS_DATA = 'SET_OFFERS_DATA';
export const SET_STORIES_DATA = 'SET_STORIES_DATA';